"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _teaserGridItem = _interopRequireDefault(require("../teaser-grid-item"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  grid: {
    display: "grid",
    gap: theme.spacing(2),
    gridTemplateColumns: "repeat(2, 1fr)",
    [theme.breakpoints.up("md")]: {
      gap: theme.spacing(3),
      gridTemplateColumns: "repeat(3, 1fr)"
    },
    [theme.breakpoints.up("lg")]: {
      gridTemplateColumns: "repeat(4, 1fr)"
    }
  }
}));
const TeaserGrid = props => {
  const {
    data,
    lang,
    mediaFormat
  } = props;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data && /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.grid,
    my: 6
  }, data.map((item, index) => {
    const {
      id,
      link,
      media,
      title
    } = item;
    return /*#__PURE__*/_react.default.createElement(_teaserGridItem.default, {
      id: id,
      key: "".concat(index).concat(id),
      lang: lang,
      link: link,
      media: media,
      mediaFormat: mediaFormat,
      title: title
    });
  })));
};
var _default = exports.default = TeaserGrid;